import { ref, computed } from 'vue';
import { overbookingService } from '../services/overbooking.service';
export function useOverbooking(options = {}) {
    const standardCapacity = ref(options.initialStandardCapacity ?? 1);
    const overcapacity = ref(options.initialOvercapacity ?? null);
    const overflowPrice = ref(options.initialOverflowPrice ?? null);
    const priceType = ref(options.priceType ?? 'PERSON');
    const netPrice = ref(options.netPrice ?? 0);
    const isEnabled = computed(() => {
        return overbookingService.isEnabled({
            priceType: priceType.value,
            standardCapacity: standardCapacity.value,
            overcapacity: overcapacity.value,
            overflowPrice: overflowPrice.value,
        });
    });
    const canEnable = computed(() => overbookingService.canEnable(priceType.value));
    const extraSpots = computed(() => {
        return overbookingService.getExtraSpots({
            priceType: priceType.value,
            standardCapacity: standardCapacity.value,
            overcapacity: overcapacity.value,
            overflowPrice: overflowPrice.value,
        });
    });
    const validation = computed(() => {
        return overbookingService.validate({
            priceType: priceType.value,
            standardCapacity: standardCapacity.value,
            overcapacity: overcapacity.value,
            overflowPrice: overflowPrice.value,
        });
    });
    const isValid = computed(() => validation.value.valid);
    const errors = computed(() => validation.value.errors);
    function enable() {
        if (!canEnable.value)
            return;
        const defaults = overbookingService.getDefaultValues(standardCapacity.value, netPrice.value);
        overcapacity.value = defaults.overcapacity;
        overflowPrice.value = defaults.overflowPrice;
    }
    function disable() {
        overcapacity.value = null;
        overflowPrice.value = null;
    }
    function toggle() {
        if (isEnabled.value) {
            disable();
        }
        else {
            enable();
        }
    }
    function setStandardCapacity(value) {
        standardCapacity.value = Math.max(1, value);
    }
    function setOvercapacity(value) {
        overcapacity.value = value;
    }
    function setOverflowPrice(value) {
        overflowPrice.value = value;
    }
    function setPriceType(type) {
        priceType.value = type;
        if (type !== 'PERSON') {
            disable();
        }
    }
    function reset() {
        standardCapacity.value = options.initialStandardCapacity ?? 1;
        overcapacity.value = options.initialOvercapacity ?? null;
        overflowPrice.value = options.initialOverflowPrice ?? null;
    }
    return {
        standardCapacity,
        overcapacity,
        overflowPrice,
        priceType,
        isEnabled,
        canEnable,
        extraSpots,
        isValid,
        errors,
        enable,
        disable,
        toggle,
        setStandardCapacity,
        setOvercapacity,
        setOverflowPrice,
        setPriceType,
        reset,
    };
}
